import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import ExcelDownloadIcon from "assets/images/ExcelDownload.png";
import DownloadFileIcon from "components/SVGs/DownloadFile";
import Button from "components/Button";
import { gradesList, teachersList } from "services/Common";
import ExcelJS from "exceljs";
import fs from "file-saver";
import { IOption } from "features/common/Interfaces";
import { MasterDataContext } from "contexts/MasterDataContext";
import { useContext, useEffect, useState } from "react";

export const sheetColumns = ["grade name", "teacher name", "class name"];

function DownloadSample() {
  const { t } = useTranslation();
  const {
    state: { schoolDetails },
  } = useContext(MasterDataContext);
  const [grades, setGrades] = useState<IOption[]>([]);
  const [teachers, setTeachers] = useState<IOption[]>([]);

  const fetchGrades = async () => {
    try {
      const response = await gradesList();
      if (response?._statusCode === 200) {
        const list = response._entity?.map((item: any) => ({
          value: item._id,
          label: t(item._code),
        }));
        setGrades(list);
      } else throw response;
    } catch (error) {
      console.log(error);
    }
  };

  const fetchTeachers = async (schoolId: number) => {
    try {
      const response = await teachersList(schoolId);
      if (response?._statusCode === 200) {
        const list = response._entity?.map((item: any) => ({
          value: item._teacherId,
          label: `${item?._name ?? ""} ${item?._lastName ?? ""}`,
        }));
        setTeachers(list);
      } else throw response;
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchGrades();
    if (schoolDetails?.schoolId) fetchTeachers(schoolDetails?.schoolId);
  }, [schoolDetails?.schoolId]);

  const downloadHandler = async () => {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("classes-details");
    sheet.protect("", {});

    sheet.columns = [
      {
        header: t(sheetColumns[0]),
        key: sheetColumns[0],
        width: 30,
        protection: { locked: true },
      },
      {
        header: t(sheetColumns[1]),
        key: sheetColumns[1],
        width: 50,
      },
      {
        header: t(sheetColumns[2]),
        key: sheetColumns[2],
        width: 30,
      },
    ];
    for (let i = 2; i < 300; i++) {
      sheet.addRow({
        [sheetColumns[0]]: "",
        [sheetColumns[1]]: "",
        [sheetColumns[2]]: "",
      });

      // sheet.getCell(`A${i}`).dataValidation = {
      //   type: "list",
      //   allowBlank: false,
      //   showErrorMessage: true,
      //   errorStyle: "error",
      //   errorTitle: t("grade name"),
      //   error: t("Invalid grade name"),
      //   formulae: [`"${grades.map((grade) => grade.label).join(",")}"`],
      // };

      // sheet.getCell(`B${i}`).dataValidation = {
      //   type: "list",
      //   allowBlank: false,
      //   showErrorMessage: true,
      //   errorStyle: "error",
      //   errorTitle: t("teacher name"),
      //   error: t("Invalid teacher name"),
      //   formulae: [`"${teachers.map((teacher) => teacher.label).join(",")}"`],
      // };

      sheet.getCell(`A${i}`).protection = { locked: false };
      sheet.getCell(`B${i}`).protection = { locked: false };
      sheet.getCell(`C${i}`).protection = { locked: false };
    }

    const file = await workbook.xlsx.writeBuffer();
    const blob = new Blob([file], { type: "xlsx" });
    fs.saveAs(blob, "class_list_sample.xlsx");
  };

  return (
    <Typography
      component="div"
      sx={{
        width: "100%",
        height: "54px",
        backgroundColor: "rgb(248 248 248)",
        borderRadius: "8px",
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
        justifyContent: "space-between",
      }}
    >
      <Typography
        component="div"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "0 15px",
          userSelect: "none",
        }}
      >
        <img
          src={ExcelDownloadIcon}
          style={{ width: "22px", height: "30px" }}
          alt="students upload sample excel"
        />
        <Typography
          component="span"
          sx={{
            padding: "0 5px",
            color: "rgb(105 123 140)",
            fontSize: "12px",
            fontWeight: "bold",
          }}
        >
          class_list_sample.XLSX
        </Typography>
      </Typography>
      <Button
        label={t("Download file")}
        action={downloadHandler}
        styles={{
          width: "150px",
          margin: "5px 10px",
          fontSize: "12px",
          fontWeight: "bold",
        }}
        Icon={<DownloadFileIcon sx={{ width: "28px", padding: "0 5px" }} />}
      />
    </Typography>
  );
}

export default DownloadSample;
